import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect, useRef } from 'react'
import { Loader2 } from 'lucide-react'
import { supabase } from '@/integrations/supabase/client'
import { toast } from 'sonner'

export const Route = createFileRoute('/auth/gsc-callback')({
  component: GscCallback,
})

function GscCallback() {
  const navigate = useNavigate()
  const called = useRef(false)

  useEffect(() => {
    if (called.current) return
    called.current = true

    const params = new URLSearchParams(window.location.search)
    const code = params.get('code')
    const state = params.get('state')

    if (!code || !state) {
      toast.error('Nieprawidłowe parametry autoryzacji Google')
      navigate({ to: '/projekty' })
      return
    }

    let projectId: string | undefined
    try {
      const statePayload = JSON.parse(atob(state))
      projectId = statePayload.projectId
      const savedState = sessionStorage.getItem(`gsc_oauth_state_${projectId}`)
      if (savedState !== state) {
        toast.error('Błąd bezpieczeństwa — niezgodność parametru state')
        navigate({ to: '/projekty' })
        return
      }
      sessionStorage.removeItem(`gsc_oauth_state_${projectId}`)
    } catch {
      toast.error('Nieprawidłowy parametr state')
      navigate({ to: '/projekty' })
      return
    }

    const redirectUri = `${window.location.origin}/auth/gsc-callback`
    supabase.functions
      .invoke('gsc-oauth', { body: { action: 'callback', code, state, redirect_uri: redirectUri } })
      .then(({ data, error }) => {
        if (error || !data?.success) {
          toast.error('Nie udało się połączyć z Google Search Console')
          navigate({ to: '/projekty/$projectId/gsc', params: { projectId: projectId! } })
          return
        }
        toast.success('Połączono z Google Search Console')
        navigate({ to: '/projekty/$projectId/gsc', params: { projectId: data.project_id } })
      })
      .catch(() => {
        toast.error('Błąd połączenia z serwerem')
        navigate({ to: '/projekty' })
      })
  }, [navigate])

  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-4">
      <Loader2 className="h-10 w-10 animate-spin" style={{ color: 'var(--accent-primary)' }} />
      <p className="text-sm" style={{ color: 'var(--text-muted)' }}>
        Łączę z Google Search Console...
      </p>
    </div>
  )
}
